import React from 'react';
import styled from 'styled-components';
import TextComponent from '../TextComponent';
import theme from '@/styles/theme';

interface Props {
  label: string;
  content?: string | JSX.Element[];
  edit?: () => void;
}

const LabelContent = (props: Props) => {
  const { label, content, edit } = props;

  return (
    <Wrapper>
      <Label>
        <LabelText>{label}</LabelText>
        {!!edit && (
          <EditButton onClick={() => edit()}>
            <EditButtonText>수정</EditButtonText>
          </EditButton>
        )}
      </Label>
      <Content>
        <TextComponent color={theme.DF_COLOR.BLACK} fontWeight={400} fontSize={20}>
          {content}
        </TextComponent>
      </Content>
    </Wrapper>
  );
};

export default LabelContent;

const Wrapper = styled.div`
  width: 100%;
  flex: 1;
`;

const Label = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const LabelText = styled(TextComponent)`
  color: ${theme.utils.withOpacity(theme.DF_COLOR.BLACK, 0.45)};
  font-weight: 500;
  margin-right: 10px;
`;
const Content = styled.div``;

const EditButton = styled.button`
  padding: 0;
  text-decoration: underline;
  text-decoration-color: ${theme.DF_COLOR.GREEN500};
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;

const EditButtonText = styled(TextComponent)`
  font-size: 18px;
  font-weight: 400;
  color: ${theme.DF_COLOR.GREEN500};
`;
